import { ExtendedTheme, Step, StepLabel, Stepper } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';

interface Props {
  steps: string[];
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    stepper: {
      gap: theme.spacing(1),
      padding: 0
    }
  })
);

export const ProcessStepper = ({ steps }: Props) => {
  const classes = useStyles();

  return (
    <Stepper orientation="vertical" connector={<></>} className={classes.stepper}>
      {steps.map((step, index) => (
        <Step active key={index}>
          <StepLabel>{step}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
